import { useEffect, useState } from 'react';
import { api, type StaffStatusRow } from '../api';

export function StaffPageStatus() {
  const [rows, setRows] = useState<StaffStatusRow[]>([]);

  useEffect(() => {
    api.staffStatus().then((result) => setRows(result.rows)).catch(() => setRows([]));
  }, []);

  return (
    <section className="panel">
      <div className="section-head">
        <h2>Staff page patterns</h2>
        <span>{rows.length} configured outlets</span>
      </div>
      <div className="table-wrap">
        <table>
          <thead>
            <tr>
              <th>Outlet</th>
              <th>Tier</th>
              <th>Last fetched</th>
              <th>Parsed</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={`${row.outlet}-${row.tier_rank}`}>
                <td>{row.outlet}</td>
                <td>{row.tier_rank}</td>
                <td>{row.last_fetched_at ? new Date(row.last_fetched_at * 1000).toLocaleString() : 'Not fetched'}</td>
                <td>{row.parsed_journalists_count ?? 0}</td>
              </tr>
            ))}
            {rows.length === 0 && (
              <tr>
                <td colSpan={4}>No staff page data yet.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </section>
  );
}
